/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate file types in the overall application.
   Developer: Aashish Singh, Created Date: 10-Sept-2023 
</summary>
*/
enum fotaFileTypeEnum{
    NoConvert=0,
    ASCII=1,
}

export default fotaFileTypeEnum